module.exports = __webpack_public_path__ + "assets/images/icons/babies.svg?v=bd127e84";